import { render, staticRenderFns } from "./UserRequestFreezerDetail.vue?vue&type=template&id=40ae7e65&"
import script from "./UserRequestFreezerDetail.vue?vue&type=script&lang=js&"
export * from "./UserRequestFreezerDetail.vue?vue&type=script&lang=js&"
import style0 from "./UserRequestFreezerDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports